<template>
  <!-- 打印客户信息 -->
  <div>
    <div class="main" id="print" ref="print">
      <div class="content">
        <div class="title">客户信息</div>
        <div class="footer">
          <div class="kehu">

            <div class="p">客户ID：{{ userData.id }}</div>
            <div class="p">客户名：{{ userData.realname }}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    userData: { type: Object }
  },

  created() {
    // this.$nextTick(() => {
    //   this.$print(this.$refs.print)
    // })
  },
  methods: {
    print() {
      this.$print(this.$refs.print)
    },
  },
}
</script>

<style lang="scss" scoped>
.main {
  width: 1181px;
  height: 1772px;
  background: #fff;
  padding: 60px;
  box-sizing: border-box;
  color: #000000 !important;

  div {
    box-sizing: border-box;
    font-weight: 600 !important;
  }

  .content {
    width: 1061px;
    height: 1652px;

    border: 8px solid #000000;
    border-top: 0;
    position: relative;
    padding-top: 160px;

    .title {
      position: absolute;
      left: -8px;
      top: 0;
      width: 1061px;
      height: 160px;
      background: #000000;
      text-align: center;
      line-height: 160px;
      font-size: 80px;

      color: #ffffff;
      margin: 0;
    }

    .footer {
      width: 100%;
      height: 1492px;
      // background-color: pink;
      padding: 108px 60px 950px 60px;

      .kehu {
        .p {
          font-size: 100px;

          color: #000000 !important;
        }
      }
    }
  }
}
</style>
